import React from 'react';
import c from 'classnames';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Highlight } from 'react-instantsearch';

import Avatar from '../../../../Avatar';
import CoreLink from '../../../../CoreLink';
import type { SearchForumPostHit as PostHit } from '../../../types';
import Header from '../Header';

export interface SearchForumPostHitProps {
  hit: PostHit;
}

const SearchForumPostHit: React.FC<SearchForumPostHitProps> = (props) => {
  const { hit } = props;

  const { t } = useTranslation();

  const url = hit.url[0];
  const createdDate = moment.unix(hit.post_created[0]);
  const body = hit.post_body_searchable?.[0];
  const authorAvatar = hit.post_author_avatar?.[0] || 1;
  const authorNickname = hit.post_author_nickname?.[0] || t('pages.forum.anonymous');
  const classes = c('SearchForum__Hit', 'SearchForum__Hit__Post', 'u-link-box');

  return (
    <div className={classes}>
      <div className="SearchForum__Hit__inner">
        <Header entityType="node" createdDate={createdDate} />

        <div className="SearchForum__Hit__author">
          <Avatar avatar={authorAvatar} />
          <div className="SearchForum__Hit__author__nickname">
            {authorNickname}
          </div>
        </div>

        <CoreLink href={url} className="SearchForum__Hit__link">
          <Highlight attribute="post_title" hit={hit} />
        </CoreLink>

        {body && (
          <div className="SearchForum__Hit__body">
            <Highlight attribute="post_body_searchable" hit={hit} />
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchForumPostHit;
